import { render, staticRenderFns } from "./Form2.vue?vue&type=template&id=f95d5c66&scoped=true"
import script from "./Form2.vue?vue&type=script&lang=ts"
export * from "./Form2.vue?vue&type=script&lang=ts"
import style0 from "./Form2.vue?vue&type=style&index=0&id=f95d5c66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f95d5c66",
  null
  
)

export default component.exports